import { otmsHttp, bfsUserWebHttp } from '@/utils/http/index';

/**
 * 查询所有货主并为企业的
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/19213
 */
export function getByCorp(data, query) {
  return otmsHttp.post('/customer/page_by_corp', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 查询所有货主并为企业的集合
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/19219
 */
export function getCustomer(data) {
  return otmsHttp.post('/customer/corp/list', data);
}

/**
 * 查询租户列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/8432
 */
export function getTenantList(data) {
  return bfsUserWebHttp.post('/bfs-user/tenant/list', data);
}
